import { render, staticRenderFns } from "./FaultRecord.vue?vue&type=template&id=179b9d3e&"
import script from "./FaultRecord.vue?vue&type=script&lang=js&"
export * from "./FaultRecord.vue?vue&type=script&lang=js&"
import style0 from "./FaultRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports